import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const PowerFunction: HelperFunction = {
	tokenName: 'POWER',
	nodeType: functionNodeTypes.Power,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 2) {
			return err(evaluatorErrorWithNode('POWER function expects exactly two arguments', node))
		}
		const baseResult = evaluateExpr(node.arguments[0])
		if (baseResult.isErr()) return err(baseResult.error)
		const expResult = evaluateExpr(node.arguments[1])
		if (expResult.isErr()) return err(expResult.error)
		return ok(Math.pow(Number(baseResult.value), Number(expResult.value)))
	}
}
